/**
 * Legacy module — preserved as an empty module so existing dependencies
 * (`acme.common.service.config`) keep resolving.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/config/config.service.ts
 *
 * It's registered with AngularJS in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * via downgradeInjectable, so any `$inject = ['ConfigService']` resolves to
 * the Angular 18 class.
 */
angular.module('acme.common.service.config', [
  'acme.common.service.api',
  'angularUUID2'
]);
